import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchAdsWithPdfConversionFailureProps = { startDate: Moment; endDate: Moment };

export type FetchAdsWithPdfConversionFailure = (
  dates: FetchAdsWithPdfConversionFailureProps,
) => void;

const fetchAdsWithPdfConversionFailure = ({
  startDate,
  endDate,
}: FetchAdsWithPdfConversionFailureProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport("ads_with_pdf_conversion_failure", dispatch, params);
};

export default fetchAdsWithPdfConversionFailure;
